<template>
  <div class="lives-wrapbox">
    <project-list :checked-list="info.subjects" />
  </div>
</template>
<script>
  /**
   * 专题自定义菜单
   */
  import projectList from './project-list';
  export default {
    name: 'component-special',
    components: {
      projectList
    },
    props: {
      info: {
        required: false
      }
    }
  };
</script>
<style lang="less">
  .lives-wrap {
    width: 100%;
    margin-bottom: 16px;
  }
</style>
